import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { TaskApprovementStatusEnum } from '@zaoblako/shared/modules/task/enum/task.approvement.status.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';

import * as yup from 'yup';

/** Budget request approver - approval scheme participant with approvement status (not editable, response body only) */
export interface BudgetRequestApproverFindInterface {
  /** Current approvement status */
  status: TaskApprovementStatusEnum;
  /** Approver last update date */
  updated: Date;
  /** Approver user data */
  user: UserFindInterface;
  /** Can current authorized user approve budget request */
  canApprove: boolean;
}

/** Budget request approver - approval scheme participant with approvement status (not editable, response body only) - DTO schema */
export const BudgetRequestApproverFindDto = SerdeDtoClass.create<BudgetRequestApproverFindInterface>(TaskDtoKeysEnum.BUDGET_REQUEST_APPROVER_FIND_DTO, {
  status: {
    label: 'Статус',
    serializer: yup
      .string()
      .oneOf(Object.values(TaskApprovementStatusEnum)),
  },
  updated: {
    label: 'Обновлён',
    serializer: yup.date(),
  },
  user: {
    optional: true,
    label: 'Пользователь',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  canApprove: {
    label: 'Может согласовывать',
    serializer: yup.boolean(),
  },
});
